import { SearchIndex } from 'emoji-mart';

export const getEmojiNative = (id: string): string => {
  const result = (SearchIndex as any).get(id);
  return result?.skins?.[0]?.native;
};
